import { format } from "date-fns";
import api from "./api";

//const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/employee-posting`,payload);
export const postingEmployees = async (payload) => {
  await api.post(`/api/employee-posting`, payload);

};

export const getVerifiedEmployeesForPosting = async () => {
  const response = await api.get(`/api/documents-verification/status/ACTIVE`);
  return response.data;
};

export const fetchLocations = async (postingDistrict, postingProject) => {
  const response = await api.get(`/api/locations/by-district/${postingDistrict}/${postingProject}`);
  return response.data;
}

export const getDesignationSummary = async (stateId, districtId) => {

  try {
    let url = `/api/requirements/designation-summary?stateId=${stateId}`;

    if (districtId) {
      url += `&districtId=${districtId}`;
    }
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching location hierarchy report:", error);
    throw error;
  }
};

export const getDesignationSummaryDrillDown = async (stateId, designation, districtId) => {
  try {
    let url = `/api/requirements/location-designation-details?stateId=${stateId}&designation=${designation}`;

    if (districtId) {
      url += `&districtId=${districtId}`;
    }
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching location hierarchy report:", error);
    throw error;
  }
};


// http://192.168.1.121:8080/api/employee-posting/employee-counts?stateId=3&year=2026&month=9
export const getPostedAndRelievedCount = async (stateId, districtId, year, month,) => {
  let url = `api/employee-posting/employee-counts?stateId=${stateId}&year=${year}&month=${month}`;

  if (districtId !== null && districtId !== undefined && districtId !== "") {
    url += `&districtId=${districtId}`;
  }


  const response = await api.get(url);
  return response.data;
};

// drill down api  attendance compare
// http://192.168.1.121:8080/api/employee-posting/district-posting-releaving-counts?stateId=3&designation=cro&year=2026&month=9
export const getPostedAndRelievedCountDrilldown = async (stateId, districtId, year, month, designation) => {
  let url = `api/employee-posting/district-posting-releaving-counts?stateId=${stateId}&year=${year}&month=${month}`;

  if (districtId !== null && districtId !== undefined && districtId !== "") {
    url += `&districtId=${districtId}`;
  }
  if (designation !== null && designation !== undefined && designation !== "") {
    url += `&designation=${designation}`;
  }

  const response = await api.get(url);
  return response.data;
};

// employee Drill down api attendace
// http://192.168.1.121:8080/api/employee-posting/district-posting-releaving-employees?districtId=5&year=2026&month=9
export const getPostedAndRelievedCountDistDrilldown = async (districtId, year, month, designation) => {
  let url = `/api/employee-posting/district-posting-releaving-employees?districtId=${districtId}&year=${year}&month=${month}`;

  const response = await api.get(url);
  return response.data;
};

//employee Attendance tracking
// http://192.168.1.121:8080/api/location-tracking/daily-tracking?stateId=3&districtId=39&date=2026-10-09
export const getTrackingDetails = async (stateId, districtId, date,) => {

  const formatDate = format(date, 'yyyy-MM-dd');

  let url = `api/location-tracking/daily-tracking?stateId=${stateId}&districtId=${districtId}&date=${formatDate}`;



  const response = await api.get(url);
  return response.data;
};


//employee Attendance tracking
// http://192.168.1.121:8080/api/location-tracking/monthly-tracking?stateId=3&districtId=39&employeeUniqueId=226757&year=2026&month=10
export const getTrackingMonthlyDetails = async (stateId, districtId, employee, year, month) => {


  let url = `api/location-tracking/monthly-tracking?stateId=${stateId}&districtId=${districtId}&employeeUniqueId=${employee}&year=${year}&month=${month}`;



  const response = await api.get(url);
  return response.data;
};


// http://localhost:8080/api/location-tracking/district-movement-summary?stateId=3&date=2026-10-14
export const getEmployeeMonitoring = async (stateId, districtId, date) => {
  const formatDate = format(date, 'yyyy-MM-dd');
  try {
    let url = `/api/location-tracking/district-movement-summary?stateId=${stateId}&date=${formatDate}`;

    if (districtId !== null && districtId !== undefined && districtId !== "" && districtId !== "ALL") {
      url += `&districtId=${districtId}`;
    }
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching location hierarchy report:", error);
    throw error;
  }
};

// http://localhost:8080/api/location-tracking/flagged-tracking-report?stateId=3&districtId=1&date=2026-10-14

export const getAllEmployeesTracking = async (stateId, districtId, date,) => {

  const formatDate = format(date, 'yyyy-MM-dd');

  let url = `/api/location-tracking/flagged-tracking-report?stateId=${stateId}&districtId=${districtId}&date=${formatDate}`;



  const response = await api.get(url);
  return response.data;
};


// http://localhost:8080/api/location-tracking/daily-attendance-summary?stateId=3&date=2026-10-14
export const getStateWiseEmployeeMonitoring = async (stateId, districtId, date) => {
  const formatDate = format(date, 'yyyy-MM-dd');
  try {
    let url = `/api/location-tracking/daily-attendance-summary?stateId=${stateId}&date=${formatDate}`;

    if (districtId !== null && districtId !== undefined && districtId !== "" && districtId !== "ALL") {
      url += `&districtId=${districtId}`;
    }
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching location hierarchy report:", error);
    throw error;
  }
};


// http://192.168.1.121:8080/api/location-tracking/filtered-tracking-report?stateId=3&date=2026-10-14&status=WithDeviation&page=0&size=10

export const getAllStateWiseEmployeesTracking = async (stateId, districtId, date, status, page = 0, size = 10) => {
  const formattedDate = format(date, 'yyyy-MM-dd');

  let url = `/api/location-tracking/filtered-tracking-report?stateId=${stateId}&date=${formattedDate}&status=${status}&page=${page}&size=${size}`;

  if (districtId && districtId !== 'ALL') {
    url += `&districtId=${districtId}`;
  }

  const response = await api.get(url);
  return response.data;
};



export const submitEmployeeTransfer = async (payload, attachmentFile) => {
  try {
    const body = new FormData();
    body.append('data', JSON.stringify(payload));

    // ✅ Always include the "file" part.
    //    - When a file is selected  → send the File object
    //    - When no file is selected → send an empty string (backend sees a non-file part)
    //      This keeps the request valid multipart without changing the endpoint.
    if (attachmentFile) {
      body.append('file', attachmentFile);
    } else {
      body.append('file', ''); // or simply don't append — see notes below
    }

    // ✅ Do NOT set Content-Type manually — the browser sets the boundary.
    //    Setting it (even to 'multipart/form-data') strips the boundary and breaks parsing.
    const response = await api.post(`/api/employee-transfer`, body, {
      headers: { 'Content-Type': undefined }, // remove any inherited JSON default
    });

    return response.data;
  } catch (error) {
    const message =
      error.response?.data?.error ||
      error.response?.data?.message ||
      'Something went wrong. Please try again.';
    throw new Error(message);
  }
};